module.exports = __webpack_public_path__ + "static/media/whatsapp_help.c8353f72.svg";